import { Button } from 'rebass';
import { Dialog } from '@reach/dialog';
import { IoMdClose } from 'react-icons/io';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import CtaBody from './CtaBody';

const StyledDialog = styled(Dialog)`
  &[data-reach-dialog-content] {
    background: ${props => props.theme.colors.grey95};
    max-width: 420px;
    box-sizing: border-box;
    width: auto;

    @media (pointer: fine) {
      border-radius: 8px;
    }
  }
`;

const CtaDialog = ({ on, onClose }) => (
  <StyledDialog isOpen={on} style={{ position: 'relative' }} bg="grey90">
    <Button
      type="button"
      onClick={onClose}
      borderRadius="50%"
      bg="grey90"
      px={3}
      py={3}
      style={{
        position: 'absolute',
        top: '10px',
        left: '10px',
        outline: 'none',
        cursor: 'pointer',
      }}
    >
      <IoMdClose style={{ color: '#333', display: 'block' }} />
    </Button>
    <CtaBody />
  </StyledDialog>
);

CtaDialog.propTypes = {
  on: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default CtaDialog;
